import { Box, Icon } from '@bechtel/gds';
import { ZoneCheck } from '@bechtel/sr-types';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconButtonStyled, MultiLingualText, SidebarProps, useAppUser } from '~/components';
import { SectionList } from './section-list';
import { BackSectionStyled, ContainerStyled, NavigationStyled } from './styled';

export const Sidebar: FC<SidebarProps> = ({
  sectionData,
  mode,
  hideBackIcon = false,
  hideStatus = false,
  permissionCheck = false,
}) => {
  const navigate = useNavigate();
  const { userAccount } = useAppUser();
  // The "Raceway Wrap" item in the left menu should only be shown when project
  // WrapZoneDefinitionLevel >= ZoneCheck.NoValidation
  const wrapZoneDefinitionLevel = userAccount?.tenantConfig?.wrapZoneDefinitionLevel;
  // Adding the "hidden" key with a boolean value
  const updatedData = sectionData.map((item) => {
    if (item.title === 'Wraps') {
      return {
        ...item,
        hidden: wrapZoneDefinitionLevel ? wrapZoneDefinitionLevel >= ZoneCheck.NO_VALIDATION : false,
      };
    }
    return item;
  });

  return (
    <ContainerStyled>
      {!hideBackIcon && (
        <BackSectionStyled>
          <Box>
            <IconButtonStyled
              css={`
                ${({ theme }) => `background-color: ${theme.colors.grey[100]};`}
              `}
              onClick={() => {
                navigate('..');
              }}
            >
              <Icon icon="arrow-left" fillColor="grey.900" />
            </IconButtonStyled>
          </Box>
          <Box flexGrow={{ sm: '1' }}>
            <MultiLingualText color="grey.900" size="400">
              Back
            </MultiLingualText>
          </Box>
        </BackSectionStyled>
      )}
      <NavigationStyled hideBackIcon={hideBackIcon}>
        <SectionList items={updatedData} mode={mode} hideStatus={hideStatus} permissionCheck={permissionCheck} />
      </NavigationStyled>
    </ContainerStyled>
  );
};
